import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable()
export class NologinInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {

            //this.loginService.clearLocalStorage();
            //this.router.navigate(['login']);
            //redirect to / root page
            //force with a javascript redirect so go outside angular - take the apiwizard url
            console.log('Unauthorized - redirecting to login page');
            //window.location.href = environment.apiWizardUrl;
      
        }

        if (!environment.production) {
          console.error(err);
        }
        const error = (err && err.error && err.error.message) || err.statusText;
        return throwError(error);
      })
    );
  }
  /*
  In a production-ready app, we may need to implement another service to gracefully handle all errors. We will not discuss that in this article.

  */
}
